var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll_wrap",style:({width:_vm.wid+'px'})},[_c('div',{attrs:{"id":"box"}},[_c('div',{ref:"marquee",attrs:{"id":"marquee"}},[_vm._v(_vm._s(_vm.info))]),_c('div',{attrs:{"id":"copy"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }